import { FC } from 'react';

import { usePage } from '@inertiajs/react';

import { ReviewsPagination } from './ReviewsPagination';
import { SellerReviewCard } from './SellerReviewCard';
import { UserReviewSummary } from './UserReviewSummary';
import { Card, CardContent } from '../../components/ui/Card';
import { userReviewsRoute } from '../../models/routes';
import { OrderReview, OrderReviewStats, PublicUser } from '../../types';

type PageProps = {
    user: PublicUser;
    reviews: OrderReview[] | null;
    nextPage: number | null;
    reviewStats: OrderReviewStats;
};

const Reviews: FC = () => {
    const { user, reviews, nextPage, reviewStats } = usePage<PageProps>().props;
    const reviewsList = reviews || [];
    const showReviewSummary = reviewStats.count > 0;

    return (
        <>
            {showReviewSummary && (
                <section
                    className="pt-1 pb-5 sm:pt-2 sm:pb-6"
                    data-testid="seller-reviews-preview"
                >
                    <div className="container px-4 sm:px-6 lg:px-8">
                        <UserReviewSummary reviewStats={reviewStats} />
                    </div>
                </section>
            )}

            <section className="pb-8">
                <div className="container space-y-5 px-4 sm:px-6 lg:px-8">
                    {reviewsList.length > 0 ? (
                        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                            {reviewsList.map((review) => (
                                <SellerReviewCard
                                    key={review.id}
                                    review={review}
                                />
                            ))}
                        </div>
                    ) : (
                        <Card>
                            <CardContent className="p-6 text-sm text-muted-foreground">
                                У цього продавця ще немає відгуків.
                            </CardContent>
                        </Card>
                    )}

                    <ReviewsPagination
                        url={userReviewsRoute(user.nickname)}
                        nextPage={nextPage}
                    />
                </div>
            </section>
        </>
    );
};

export default Reviews;
